<template>
  <list-form
    action-type="create"
    :list-value-data="listValueData"
    :submit-button-disabled="submitButtonDisabled"
    :loading="loading"
    @save="createList"
    @updateListItems="updateListItems"
  />
</template>

<script>
import ListForm from "@/components/SystemManagement/SystemSettings/ListsSettings/ListForm";
import { mapActions } from "vuex";

export default {
  name: "NewCustomList",

  components: { ListForm },

  data() {
    return {
      listValueData: {
        name: "",
        definition: null,
        custom_list: true
      },
      loading: false,
      fieldsAreValid: true,
      listItems: [],
      list: null
    };
  },

  computed: {
    /**
     * Indicates if the submit button is disabled or not
     * @return {Boolean}
     */
    submitButtonDisabled() {
      return !this.listValueData.name;
    }
  },

  methods: {
    ...mapActions(["createCustomList", "createCustomListValue"]),

    /**
     * Creates the custom list and asks for the creation of the list values
     */
    async createList() {
      try {
        this.loading = true;
        let dataToSend = {
          name: this.listValueData.name
        };
        if (this.listValueData.definition) {
          dataToSend.definition = this.listValueData.definition;
        }
        this.list = await this.createCustomList(dataToSend);
        this.saveListItems();
      } catch (e) {
        console.error(e);
        this.$toasted.global.toast_error(e.response.data.data);
      } finally {
        this.loading = false;
      }
    },

    /**
     * Saves the list items
     */
    async saveListItems() {
      try {
        this.loading = true;
        this.listItems.forEach(async item => {
          let dataToSend = {
            list_id: this.list.id,
            code: item.code
          };
          if (item.libelle) {
            dataToSend.libelle = item.libelle;
          }
          await this.createCustomListValue(dataToSend);
        });
        this.$router.back();
      } catch (e) {
        console.error(e);
        this.$toasted.global.toast_error(e.response.data.data);
      } finally {
        this.loading = false;
      }
    },

    /**
     * Emits an event to update the list items in the parent component
     */
    updateListItems($event) {
      this.listItems = $event;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/ListsSettings/NewCustomList.vue